import { shopify, common, shopline, shoplazza } from '@/constant/company';
import { companyUUID } from '@/service/api';
import { AOWEI, POVISON, SMALLRIG, STORAGE_KEY } from '@/constant/constant';
import { getLocal, getSession, setLocal } from '@/utils/storage';
import { safeJsonParse } from '@/utils/safeJsonParse';
import { isShopifyOrTest, isCommonOrTest, isShoplineOrTest } from '@/utils/platform';
import { isKnownCrawlerUA } from '@/utils/isKnownCrawlerUA';
const debug = require('debug')('cartsee:experiment');

/**
 * 是否开启事件回调
 */
export const isEnableEventCallback = () => {
  return [shopify[30], ...POVISON].includes(companyUUID);
};

/**
 * 是否开启事件触发加购
 */
export const isEnableCartxtrackAddCart = () => {
  return [...POVISON, ...SMALLRIG, 'm9qqf2m0', common[2558]].includes(companyUUID);
};

/**
 * 屏蔽爬虫流量（具名 UA 串，fail-open）。
 * 命中后 index 入口零请求早退：不打任何业务接口、不初始化弹窗/埋点。
 */
export const isBlockSpider = () => {
  const isHitSpiderUserAgent = isKnownCrawlerUA();
  debug('isBlockSpider isHitSpiderUserAgent=%o ua=%s', isHitSpiderUserAgent, navigator.userAgent);
  return isHitSpiderUserAgent;
};

/** 是否关闭表单事件上报 */
let FORM_EVENT_SENDED_FLAG = false;
export const isDisableFormEvent = (params) => {
  return true;
  const popupConfig = safeJsonParse(getSession(STORAGE_KEY.POPUP), { rets: [] });
  const noHasPopup = popupConfig.rets.length === 0;
  const whiteEvents = ['user_active'].includes(params.event);
  const isDisableFormEvent = noHasPopup && !whiteEvents;

  if (isDisableFormEvent && !FORM_EVENT_SENDED_FLAG) {
    FORM_EVENT_SENDED_FLAG = true;
    debug('isDisableFormEvent noHasPopup=%o whiteEvents=%o', noHasPopup, whiteEvents);
  }
  return isDisableFormEvent;
};

export const isEnableNewsletterMonitor = () => {
  return AOWEI.includes(companyUUID);
};
